module.exports = __webpack_public_path__ + "static/media/view5.f5e4ca14.jpg";